import { render, staticRenderFns } from "./ListSituacao.vue?vue&type=template&id=7d63798c"
import script from "./ListSituacao.vue?vue&type=script&lang=js"
export * from "./ListSituacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports